module.exports = __webpack_public_path__ + "img/flecha-siguiente.fdcf752b.svg";